<script setup lang="ts">
/**
 * A pictogram per tool, keyed by the catalogue id. Lives here rather than in
 * `tools.ts`, which must stay free of anything the Vite config cannot load.
 * Drawn in `currentColor` so the card decides the colour, and the theme with it.
 */
defineProps<{ id: string }>()
</script>

<template>
  <svg
    class="tool-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <!-- A network split in halves, then quarters: what the calculator does. -->
    <template v-if="id === 'subnet-calculator'">
      <rect x="3" y="4" width="18" height="4" rx="1" />
      <rect x="3" y="10" width="8.5" height="4" rx="1" />
      <rect x="12.5" y="10" width="8.5" height="4" rx="1" />
      <rect x="3" y="16" width="3.75" height="4" rx="1" />
      <rect x="7.75" y="16" width="3.75" height="4" rx="1" />
    </template>
    <!-- A screen and its diagonal, the two inputs to pixel density. -->
    <template v-else-if="id === 'ppi-calculator'">
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M9 20h6M12 16v4M7 12.5l10-5" />
    </template>
    <template v-else-if="id === 'psu-calculator'">
      <path d="M13 3 5 13.5h6L10 21l8-10.5h-6L13 3Z" />
    </template>
    <template v-else>
      <rect x="4" y="4" width="16" height="16" rx="2" />
    </template>
  </svg>
</template>

<style scoped>
.tool-icon {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
